/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Access_Update_FailedInputs */

const en_document_access_update_failed = /** @type {(inputs: Document_Access_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update document`)
};

const id_document_access_update_failed = /** @type {(inputs: Document_Access_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal memperbarui dokumen`)
};

/** @type {(inputs: Document_Access_Update_FailedInputs) => LocalizedString} */
const es_document_access_update_failed = en_document_access_update_failed;

/** @type {(inputs: Document_Access_Update_FailedInputs) => LocalizedString} */
const fr_document_access_update_failed = en_document_access_update_failed;

/** @type {(inputs: Document_Access_Update_FailedInputs) => LocalizedString} */
const de_document_access_update_failed = en_document_access_update_failed;

/** @type {(inputs: Document_Access_Update_FailedInputs) => LocalizedString} */
const ja_document_access_update_failed = en_document_access_update_failed;

/** @type {(inputs: Document_Access_Update_FailedInputs) => LocalizedString} */
const zh_document_access_update_failed = en_document_access_update_failed;

/** @type {(inputs: Document_Access_Update_FailedInputs) => LocalizedString} */
const ar_document_access_update_failed = en_document_access_update_failed;

/** @type {(inputs: Document_Access_Update_FailedInputs) => LocalizedString} */
const it_document_access_update_failed = en_document_access_update_failed;

/** @type {(inputs: Document_Access_Update_FailedInputs) => LocalizedString} */
const ru_document_access_update_failed = en_document_access_update_failed;

/** @type {(inputs: Document_Access_Update_FailedInputs) => LocalizedString} */
const pt_document_access_update_failed = en_document_access_update_failed;

/** @type {(inputs: Document_Access_Update_FailedInputs) => LocalizedString} */
const ko_document_access_update_failed = en_document_access_update_failed;

/**
* | output |
* | --- |
* | "Failed to update document" |
*
* @param {Document_Access_Update_FailedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_access_update_failed = /** @type {((inputs?: Document_Access_Update_FailedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Access_Update_FailedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_access_update_failed(inputs)
	if (locale === "es") return es_document_access_update_failed(inputs)
	if (locale === "fr") return fr_document_access_update_failed(inputs)
	if (locale === "de") return de_document_access_update_failed(inputs)
	if (locale === "ja") return ja_document_access_update_failed(inputs)
	if (locale === "zh") return zh_document_access_update_failed(inputs)
	if (locale === "ar") return ar_document_access_update_failed(inputs)
	if (locale === "id") return id_document_access_update_failed(inputs)
	if (locale === "it") return it_document_access_update_failed(inputs)
	if (locale === "ru") return ru_document_access_update_failed(inputs)
	if (locale === "pt") return pt_document_access_update_failed(inputs)
	return ko_document_access_update_failed(inputs)
});